import "../styles/default.scss";

import React from "react";

import withSmEventTracker from "../../../../../hocs/withSmEventTracker";
import withTranslations from "../../../../../hocs/withTranslations";
import AnalyticsEventTracker from "../../../../../lib/AnalyticsEventTracker";
import OfferModalEvent from "../../../../../lib/SalesManago/events/OfferModalEvent";
import NoPermissionModal from "../../../pages/Plans/components/NoPermissionModal";
import { withRouter } from "react-router-dom";

@withTranslations
@withSmEventTracker
@withRouter
class PremiumModal extends React.Component {
  constructor() {
    super();
  }
  componentDidMount() {
    const { name, trackSMEvent } = this.props;

    const smEvent = new OfferModalEvent(name);
    trackSMEvent(smEvent);

    AnalyticsEventTracker.trackOfferModalEvent();
  }

  render() {
    const { hideModal, permissions } = this.props;

    return (
      <NoPermissionModal hideModal={hideModal} permissions={permissions} />
    );
  }
}

export default PremiumModal;
